import React from "react";

const TYPE_COLORS = {
  Product: "hsl(var(--brand))",
  Brand: "hsl(var(--foreground))",
  Category: "hsl(var(--success))",
  Organization: "hsl(var(--warning))",
  Concept: "hsl(var(--muted-foreground))",
};

export default function KnowledgeGraphView({ graph }) {
  if (!graph?.nodes?.length) return null;
  const W = 520, H = 340, cx = W / 2, cy = H / 2;
  const center = graph.nodes.find((n) => n.id === "product") || graph.nodes[0];
  const others = graph.nodes.filter((n) => n.id !== center.id);
  const R = 130;
  const pos = { [center.id]: { x: cx, y: cy } };
  others.forEach((n, i) => {
    const a = (i / others.length) * Math.PI * 2 - Math.PI / 2;
    pos[n.id] = { x: cx + R * Math.cos(a), y: cy + R * Math.sin(a) };
  });

  return (
    <div className="overflow-hidden rounded-md border border-border bg-secondary/20" data-testid="knowledge-graph">
      <svg viewBox={`0 0 ${W} ${H}`} className="h-auto w-full">
        {graph.edges?.map((e, i) => {
          const s = pos[e.source], t = pos[e.target];
          if (!s || !t) return null;
          return (
            <g key={i}>
              <line x1={s.x} y1={s.y} x2={t.x} y2={t.y} stroke="hsl(var(--border))" strokeWidth="1.5" />
              <text x={(s.x + t.x) / 2} y={(s.y + t.y) / 2 - 3} textAnchor="middle"
                className="fill-muted-foreground font-mono" fontSize="8">{e.relation}</text>
            </g>
          );
        })}
        {graph.nodes.map((n) => {
          const p = pos[n.id];
          const isCenter = n.id === center.id;
          const color = TYPE_COLORS[n.type] || TYPE_COLORS.Concept;
          const label = n.label.length > 16 ? n.label.slice(0, 15) + "…" : n.label;
          return (
            <g key={n.id}>
              <circle cx={p.x} cy={p.y} r={isCenter ? 9 : 6} fill={color} />
              <rect x={p.x - label.length * 3.2 - 6} y={p.y + (isCenter ? 14 : 10)} width={label.length * 6.4 + 12} height="16" rx="4"
                fill="hsl(var(--card))" stroke="hsl(var(--border))" />
              <text x={p.x} y={p.y + (isCenter ? 25 : 21)} textAnchor="middle" className="fill-foreground font-mono" fontSize="9" fontWeight={isCenter ? 700 : 400}>{label}</text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
